<template>
  <div>
    <div class="b-NavMenu">
      <div class="b-container">
        <el-menu :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="rgba(0,0,0,0.4)"
                text-color="#fff"
                active-text-color="rgba(0,0,0,0.7)"
                 >
          <el-submenu index="1" style="text-align: left; margin-left: 0px">
            <template slot="title">关于我们</template>
            <el-menu-item index="1-1">
              <router-link to="/about?id=xmjj">设施简介</router-link>
            </el-menu-item>
            <el-menu-item index="1-8">
              <router-link to="/about8">研究院简介</router-link>
            </el-menu-item>
            <el-menu-item index="1-2">
              <router-link to="/about2">领导团队</router-link>
            </el-menu-item>
            <el-menu-item index="1-3">
              <router-link to="/about6?id=zhyxjd">科研设施</router-link>
            </el-menu-item>
            <el-menu-item index="1-4">
              <router-link to="/about3">技术系统</router-link>
            </el-menu-item>

            <el-menu-item index="1-5">
              <router-link to="/about5?id=yxgltx">组织架构</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="7" style="text-align: left">
            <template slot="title">&nbsp;&nbsp;&nbsp;人才队伍</template>
            <el-menu-item index="7-1">
              <router-link to="/talent?type=sskxj" onclick="location='/talent?type=sskxj';location.reload();">设施科学家</router-link>
            </el-menu-item>

            <el-menu-item index="7-4">
              <router-link to="/talent?type=sysoffice" onclick="location='/talent?type=sysoffice';location.reload();">管理队伍</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">科研服务</template>
            <el-submenu index="2-1">
              <template slot="title">分析测试</template>
              <el-menu-item index="2-1-1">
                <router-link to="/service0?id=&cat=pt" onclick="location='/service0?id=&cat=pt';location.reload();" style="height: 40px">公共仪器平台</router-link>
              </el-menu-item>
              <el-menu-item index="2-1-7">
                <a target="_blank" href="http://iac.sjtu.edu.cn">公共仪器平台仪器预约</a>
              </el-menu-item>
              <el-menu-item index="2-1-8">
                <a target="_blank" href="https://tmcore.sjtu.edu.cn">用户共享资源预约</a>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="2-2">
              <router-link to="/service0?id=&cat=zx" onclick="location='/service0?id=&cat=zx';location.reload();"  style="height: 40px">技术合作</router-link>
            </el-menu-item>
            <el-menu-item index="2-3">
              <router-link to="/service11">用户实验室</router-link>
            </el-menu-item>
            <el-menu-item index="2-4">
              <router-link to="/service12">会议服务</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">用户管理</template>
            <el-menu-item index="3-1">
              <router-link to="/kyuser2">用户指南</router-link>
            </el-menu-item>
            <el-menu-item index="3-0">
              <router-link to="/kyuser1">用户入驻</router-link>
            </el-menu-item>
            <el-menu-item index="3-2">
              <router-link to="/kyuser3">在站科研用户</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">合作交流</template>
            <el-menu-item index="4-1">
              <router-link to="/activity">联合研究中心</router-link>
            </el-menu-item>
            <el-menu-item index="4-2">
              <router-link to="/imageset">合作伙伴</router-link>
            </el-menu-item>
            <el-menu-item index="4-4">
              <router-link to="/cooperations">合作动态</router-link>
            </el-menu-item>
            <el-menu-item index="4-5">
              <router-link to="/tang">唐仲英楼</router-link>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="5">
            <template slot="title">科学研究计划</template>
            <el-menu-item index="5-2">
              <router-link to="/event2">开放研究计划</router-link>
            </el-menu-item>
            <el-menu-item index="5-3">
              <router-link to="/event1">STAR计划</router-link>
            </el-menu-item>
            <el-menu-item index="5-5">
              <router-link to="/honor_system">唐仲英荣誉体系</router-link>
            </el-menu-item>
<!--            <el-menu-item index="5-4">-->
<!--              <router-link to="/health">大健康计划</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>

          <el-submenu index="8" style="padding-left: 16px">
            <template slot="title">人才引进</template>
            <el-menu-item index="8-1">
              <router-link to="/notice?t=recruit_notice">招聘公告</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">&nbsp;&nbsp;&nbsp;&nbsp;学习专栏</template>
            <el-menu-item index="6-1">
              <router-link to="/party">党建工作</router-link>
            </el-menu-item>
            <el-menu-item index="6-2">
              <router-link to="/party1">主题教育</router-link>
            </el-menu-item>
            <el-menu-item index="6-3">
              <router-link to="/party2">特色活动</router-link>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="9" style="text-align: right">
            <template slot="title">服务指南</template>
            <el-menu-item index="9-1">
              <router-link to="/rules">规章制度</router-link>
            </el-menu-item>
            <el-menu-item index="9-2">
              <router-link to="/service12">会议室预约</router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      activeIndex: '1',
    };
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/css/base.css";

/* 导航 */
.b-NavMenu {
  margin-top: 5px;
  .el-menu {
    background: none !important;
    // display: flex;
    // align-items: center;
    // justify-content: space-around;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0 !important;
    text-align: center;
  }
  .el-menu--horizontal .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    background: none !important;
    border-left: 1px solid #fff;
  }
  .el-submenu {
    width: 144.2px;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    font-size: 16px!important;
    height: 40px !important;
    line-height: 40px !important;
    border-bottom: 0 solid transparent;
    background: none !important;
    padding-left: 0px;
    padding-right: 0px;
    //font-weight: bold!important;
    a {
      color: #fff;
    }
  }
  .el-menu-item.is-active {
    color: #fff !important;
    border-bottom: 0 !important;
    a {
      color: #fff !important;
    }
  }
  .el-menu-item {
    width: 144.2px;
    padding-left: 0px;
  }
  .el-submenu__title i {
    color: #fff;
    padding-left: 0px;
    padding-right: 0px;
  }
}
.el-menu--horizontal {
  .el-menu--popup-bottom-start {
    margin-top: 0 !important;
    background: none !important;
  }
}
.el-menu--popup {
  padding: 0 !important;
  .el-submenu {
    //border-bottom: 1px solid #fff;
  }
}
.el-menu--horizontal .el-menu .el-menu-item{
  //background-color: rgba(0,0,0,0.4)!important;
}
.el-menu--horizontal .el-menu .el-submenu__title{
  background-color: rgba(0,0,0,0.4)!important;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  float: none;
  height: 40px;
  line-height: 40px;
  padding: 0px;
  color: #fff !important;
  text-align: center;
  //border-bottom: 1px solid #fff;
  a {
    color: #fff !important;
  }
  &:last-child {
    border-bottom: 0 !important;
  }
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 140px;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 140px;
}
.el-menu--popup-right-start {
  margin: 0;
}
.el-submenu .el-menu-item {
  min-width: 140px;
}


</style>



// WEBPACK FOOTER //
// src/components/nav/index.vue